<app-header-one></app-header-one>

<div class="home-area">
    <div class="home-slides owl-carousel owl-theme">
        <div
            class="hero-banner"
            *ngFor="let slider of sliders"
            [style.background-image]="'url(' + slider.imageUrl + ')'"
        ></div>
    </div>

    <div class="main-banner-content">
        <h1>{{ "Together to preserve the human heritage" | translate }}</h1>
    </div>
</div>

<section class="listing-categories-area bg-F7F9FB pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">{{"Possibilities" | translate}}</span>
            <h2>{{ "Charity potential" | translate }}</h2>
        </div>

        <div class="row">
            <!-- <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/listing-four">
                        <i class="bx bx-shopping-bag"></i>
                        Shops
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/listing-four">
                        <i class="bx bx-bed"></i>
                        Hotels
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/listing-four">
                        <i class="bx bx-drink"></i>
                        Restaurants
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/listing-four">
                        <i class="bx bx-dumbbell"></i>
                        Fitness
                    </a>
                </div>
            </div> -->

            <!-- <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/listing-four">
                        <i class="bx bx-calendar-star"></i>
                        Events
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/listing-four">
                        <i class="bx bx-walk"></i>
                        Services
                    </a>
                </div>
            </div> -->

            <div class="col-lg-6 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/hospitals">
                        <i class="bx bx-building-house"></i>
                        {{ "Hospitals" | translate }}
                    </a>
                </div>
            </div>
            <div class="col-lg-6 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/disease">
                        <i class="bx bx-building-house"></i>
                        {{ "Diseases" | translate }}
                    </a>
                </div>
            </div>

            <!-- <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-listing-category">
                    <a routerLink="/listing-four">
                        <i class="bx bx-buildings"></i>
                        Market
                    </a>
                </div>
            </div> -->
        </div>
    </div>
</section>

<app-process></app-process>

<!-- <app-feedback></app-feedback>

<app-partner></app-partner> -->

<!-- <section class="destinations-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Browse</span>
            <h2>Popular Destinations</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-sm-12 col-md-12">
                <div class="single-destinations-box">
                    <img src="assets/img/destinations/img1.jpg" alt="image">

                    <div class="content">
                        <h3>New York</h3>
                        <div class="rating">
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                        </div>
                    </div>

                    <span class="listing-count">125 Listings</span>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-8 col-sm-12 col-md-12">
                <div class="single-destinations-box">
                    <img src="assets/img/destinations/img2.jpg" alt="image">

                    <div class="content">
                        <h3>Paris</h3>
                        <div class="rating">
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                        </div>
                    </div>

                    <span class="listing-count">50 Listings</span>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-sm-12 col-md-6">
                        <div class="single-destinations-box">
                            <img src="assets/img/destinations/img3.jpg" alt="image">
        
                            <div class="content">
                                <h3>Moscow</h3>
                                <div class="rating">
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                </div>
                            </div>
        
                            <span class="listing-count">15 Listings</span>
        
                            <a routerLink="/listing-one" class="link-btn"></a>
                        </div>
                    </div>
        
                    <div class="col-lg-6 col-sm-12 col-md-6">
                        <div class="single-destinations-box">
                            <img src="assets/img/destinations/img4.jpg" alt="image">
        
                            <div class="content">
                                <h3>London</h3>
                                <div class="rating">
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                </div>
                            </div>
        
                            <span class="listing-count">78 Listings</span>
        
                            <a routerLink="/listing-one" class="link-btn"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="blog-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Recent Story</span>
            <h2>From The Louise Blog</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog-details-one">
                            <img src="assets/img/blog/img1.jpg" alt="image">
                        </a>
                        <div class="date">
                            <span>January 29, 2020</span>
                        </div>
                    </div>

                    <div class="post-content">
                        <span class="category">Ideas</span>
                        <h3><a routerLink="/blog-details-one">Top 50 places to eat in Milwaukee</a></h3>
                        <a routerLink="/blog-details-one" class="details-btn">Read Story</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog-details-one">
                            <img src="assets/img/blog/img2.jpg" alt="image">
                        </a>
                        <div class="date">
                            <span>January 29, 2020</span>
                        </div>
                    </div>

                    <div class="post-content">
                        <span class="category">Advice</span>
                        <h3><a routerLink="/blog-details-one">28 places to visit in the USA</a></h3>
                        <a routerLink="/blog-details-one" class="details-btn">Read Story</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog-details-one">
                            <img src="assets/img/blog/img3.jpg" alt="image">
                        </a>
                        <div class="date">
                            <span>January 29, 2020</span>
                        </div>
                    </div>

                    <div class="post-content">
                        <span class="category">Social</span>
                        <h3><a routerLink="/blog-details-one">08 things to remember in Morning</a></h3>
                        <a routerLink="/blog-details-one" class="details-btn">Read Story</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
